var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advertisement flex-center user-select"},[_c('div',{staticClass:"advertisement-contents container flex-column-center",style:(("background-image: url(" + (_vm.location + _vm.backgroundAds) + ")"))},[_c('div',{staticClass:"advertisement-titles align-right text-gray text-uppercase"},[_vm._v(_vm._s(_vm.langTitles.advertisement))]),_vm._v(" "),_c('div',{staticClass:"advertisement-figure transition-slow"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3be3372","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ads/store-ads.vue
// module id = 91
// module chunks = 0